import React from 'react'
import ReactDOM from 'react-dom'

import './index.scss'
// import App from './App';
import {
  BrowserRouter as Router,
  HashRouter,
  RouterProvider,
} from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'mobx-react'
// import NNSidebar from './layouts/FixedSider'
import NNSidebar from './layouts/sidebar'
import { Config } from './config'
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router'
import CounterStore from './stores/CounterStore'
import InformStore from './stores/InformStore'
import NotificationStore from './stores/NotificationStore'
import AuthStore from './stores/AuthStore'
// import AuthStore from './stores/AuthStore'

const createBrowserHistory = require('history').createBrowserHistory
Array.prototype.getRandomVal = function() {
  return this[Math.floor(Math.random() * this.length)]
}

const browserHistory = createBrowserHistory()
const routingStore = new RouterStore()

const history = syncHistoryWithStore(browserHistory, routingStore)
const stores = {
  // Key can be whatever you want
  routingStore: routingStore,
  informStore: InformStore,
  notificationStore: NotificationStore,
  authStore: AuthStore,
  // ...other stores
}
// const store = createStore(rootReducer)
const AppWithRouter = () => (
  <Provider {...stores}>
    <HashRouter basename={Config.basename}  history={history}>
 
      <NNSidebar />
   
    </HashRouter>
  </Provider>
)

ReactDOM.render(<AppWithRouter />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()

if (module.hot) {
  module.hot.accept()
}
